import {t} from "@lingui/core/macro";
import {memoize} from "underscore";

export const strings = memoize(() => ({
    makeCopy: t`Make a copy`,
    viewOnly: t`View only`,
    share: t`Share`,
    shareLinkModal: t`Anyone with this link can view and save a copy of this document.`,
    copyLink: t`Copy link`,
    linkCopied: t`Link copied!`,
    linkCopiedError: t`Oops, something went wrong and link was not copied.`,
    clickThisToTryAgain: t`Click this to try again.`,
    savedTo: t`Saved to`,
    copySaved: t`Copy is saved in My Documents`,
    copyDisabled: t`Sorry, you can't make an editable copy of this document.`,
    getKhanmigo: t`Get Khanmigo for <bold>free</bold> to make a copy tailored for your students. You'll have access to all our other AI based teacher tools as well!`,
    khanmigoSignup: t`Sign up for Khanmigo to make a copy`,
    signup: t`Sign up for free`,
}));
